module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/th/3-96783cb956307425227610c2716c90a8.jpg";